import BaseModelAPI from '../BaseModelAPI';

export default class ReportDelayDeliveryInstructionList extends BaseModelAPI {

	static entity = 'newreport2191list'
	static entityName = 'reportdelaydeliveryinstruction';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
